// Studio Claire: Hinweis-Popup auf der Startseite.
// Nutzt <dialog> im Modal-Modus — damit kommen Fokusfalle, Escape-Taste
// und Backdrop vom Browser statt aus eigenem Code.

class StickerPopup extends HTMLElement {
  connectedCallback() {
    this.dialog = this.querySelector('dialog');
    if (!this.dialog) return;

    this.storageKey = this.getAttribute('data-key') || 'sticker-popup';
    this.frequency = this.getAttribute('data-frequency') || 'session';
    this.delay = (parseFloat(this.getAttribute('data-delay')) || 5) * 1000;

    this.close = this.close.bind(this);
    this.handleBackdrop = this.handleBackdrop.bind(this);
    this.handleClose = this.handleClose.bind(this);

    this.querySelectorAll('[data-role="close"]').forEach((button) => {
      button.addEventListener('click', this.close);
    });
    this.dialog.addEventListener('click', this.handleBackdrop);
    this.dialog.addEventListener('close', this.handleClose);

    // Im Theme-Editor immer sofort zeigen, damit die Vorschau nutzbar ist.
    if (window.Shopify && window.Shopify.designMode) {
      this.open();
      document.addEventListener('shopify:section:select', (event) => {
        if (this.closest('.shopify-section') === event.target) this.open();
      });
      return;
    }

    if (!this.shouldShow()) return;
    this.timer = setTimeout(() => this.open(), this.delay);
  }

  disconnectedCallback() {
    clearTimeout(this.timer);
  }

  get store() {
    return this.frequency === 'session' ? window.sessionStorage : window.localStorage;
  }

  shouldShow() {
    if (this.frequency === 'always') return true;
    try {
      const seen = this.store.getItem(this.storageKey);
      if (!seen) return true;
      if (this.frequency === 'session') return false;
      return Date.now() - Number(seen) > 86400000;
    } catch (error) {
      // Privater Modus oder blockierte Speicherung: lieber zeigen als gar nichts.
      return true;
    }
  }

  remember() {
    if (this.frequency === 'always') return;
    try {
      this.store.setItem(this.storageKey, String(Date.now()));
    } catch (error) {
      // ignorieren
    }
  }

  // Klick auf den Backdrop trifft das dialog-Element selbst.
  handleBackdrop(event) {
    if (event.target === this.dialog) this.close();
  }

  handleClose() {
    document.documentElement.classList.remove('sticker-popup-open');
    this.remember();
  }

  open() {
    if (this.dialog.open) return;
    if (typeof this.dialog.showModal === 'function') {
      this.dialog.showModal();
    } else {
      this.dialog.setAttribute('open', '');
    }
    document.documentElement.classList.add('sticker-popup-open');
  }

  close() {
    if (this.dialog.open && typeof this.dialog.close === 'function') {
      this.dialog.close();
    } else {
      this.dialog.removeAttribute('open');
      this.handleClose();
    }
  }
}

if (!customElements.get('sticker-popup')) {
  customElements.define('sticker-popup', StickerPopup);
}
